/**
 * Number count animation for individual numbers or multiple numbers on a page.
 *
 * This component handles the count-up animation for each statistic.
 *
 */
class NumberCounter {
  constructor(selector = ".js-counter", duration = 10000) {
    this._selector = selector;
    this._duration = duration;
    this._observer = null;
  }

  init() {
    const stats = document.querySelectorAll(this._selector);

    this._observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          this._animateNumber(entry.target);
          this._observer.unobserve(entry.target);
        }
      });
    });

    stats.forEach((stat) => {
      this._observer.observe(stat);
    });
  }

  _animateNumber(element) {
    let startTime = null;

    const originalText = element.textContent;
    const match = originalText.match(/(\d+)/);

    if (!match) return;

    const finalValue = parseInt(match[0], 10);
    const prefix = originalText.substr(0, match.index);
    const suffix = originalText.substr(match.index + match[0].length);

    // Determine the duration based on the finalValue.
    const referenceValue = 1500;
    const dynamicDuration = Math.max(
      (finalValue / referenceValue) * this._duration,
      500
    ); // set 500ms as minimum duration

    const step = (currentTime) => {
      if (!startTime) {
        startTime = currentTime;
      }

      const progress = Math.min((currentTime - startTime) / dynamicDuration, 1);
      const currentValue = Math.floor(progress * finalValue);
      element.textContent = prefix + currentValue.toLocaleString() + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        element.textContent = prefix + finalValue.toLocaleString() + suffix;
      }
    };

    requestAnimationFrame(step);
  }
}

export default NumberCounter;
